import type { Store } from 'effector'

import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { model as config, remote } from '~/shared/config'

export const $guestRegistrationLink: Store<string> = config.get(
  remote.tria_guestRegistrationLink
)

export const $signInToWatchTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('login_or_register_to_watch_content'),
  signIn: t('sign_in'),
  cancel: t('cancel'),
  signInToWatch: t('sign_in_to_watch'),
}))
